/**
 * L’identité de l’éditeur, en un seul endroit.
 *
 * Ces valeurs apparaissent dans plusieurs sections de la vitrine (positionnement,
 * pied de page, formulaire de contact). Les dupliquer, c’est prendre le risque
 * qu’une adresse change à un endroit et pas à l’autre — et une adresse de contact
 * fausse sur une page commerciale, c’est un prospect perdu sans le savoir.
 *
 * ⚠️ `EMAIL_ILYGO` est le contact UNIQUE de toute l’entreprise (règle ILYGO) :
 * jamais de hello@, contact@ ni privacy@, DPO compris. Le seul expéditeur
 * distinct est `no-reply@ilygo.ch`, réservé aux envois techniques.
 *
 * L’IDE est un identifiant légal réel (registre suisse du commerce) : il ne
 * s’invente pas et ne se recopie pas de mémoire. Source : offre commerciale du
 * 19.08.2026 et fiche d’entreprise ILYGO.
 */

/** Contact unique de l’entreprise, tous usages confondus. */
export const EMAIL_ILYGO = 'info@ilygo.ch'

/** Site institutionnel de l’éditeur. */
export const SITE_ILYGO = 'https://ilygo.ch'

/** Numéro d’identification des entreprises (IDE), qui vaut aussi numéro de TVA. */
export const IDE_ILYGO = 'CHE-135.509.084'

/** Raison sociale complète, telle qu’inscrite au registre. */
export const RAISON_SOCIALE_ILYGO = 'ILYGO Sàrl'

/**
 * Sujet du courriel engendré par le formulaire de contact.
 *
 * Il doit dire SANS AMBIGUÏTÉ de quel produit il s’agit : `info@ilygo.ch` reçoit
 * les demandes de toutes les activités de l’entreprise, et un message intitulé
 * « Demande d’information » se noie. Le nom du produit vient en tête pour que le
 * tri soit possible d’un coup d’œil, y compris depuis un téléphone.
 */
export const SUJET_CONTACT = 'Billetterie & abonnements : demande d’information'
